<template>
  <div class="list-item" @click.stop="toDetail(item)">
    <div class="imgBox">
      <img v-lazy="item.expertImage" :alt="item.title" />
    </div>
    <div class="info">
      <h3 class="title">{{ item.title }}</h3>
      <div class="expert text-overflow">
        <b>{{ item.expertName }}</b
        ><span>{{ item.expertHospitalName }}</span>
      </div>
      <div class="msg">
        <span>{{ item.videoCountText }}</span>
        <span>{{ item.playedCount }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { hostPath } from '@/public/utils/basePath'
import { jumpModuleApp, appPort } from '@/widget'
export default defineComponent({
  props: {
    item: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  methods: {
    toDetail(item) {
      if (appPort()) {
        jumpModuleApp({
          typeId: 'h5',
          url: `${hostPath}/learn/courseguide/album/${item.albumId}`
        })
      } else {
        this.$router.push({
          path: `/courseguide/album/${item.albumId}`
        })
      }
    }
  }
})
</script>

<style lang="scss" scoped>
.list-item {
  height: 206px;
  display: flex;
  .imgBox {
    width: 154px;
    height: 206px;
    border-radius: 12px;
    overflow: hidden;
    background: $grayF5;
    margin-right: 24px;
    img {
      width: 100%;
    }
  }
  .info {
    height: 206px;
    flex: 1;
    overflow: hidden;
    .title {
      height: 88px;
      line-height: 44px;
      font-size: 32px;
      @include multi-ellipsis(2);
      margin-bottom: 12px;
    }
    .expert {
      height: 40px;
      color: $gray96;
      line-height: 40px;
      font-size: 28px;
      margin-bottom: 32px;
      b {
        margin-right: 5px;
      }
    }
    .msg {
      color: $gray96;
      font-size: 24px;
      line-height: 34px;
    }
  }
}
</style>
